import React from 'react';
import './Copies.scss';

function Copy5() {
  return (
    <section className="copies marginBottomAdd">
      <h4 className="copies__title title">
        THE NEED FOR MORE DIVERSE MEDICAL TRAINING AND RESEARCH
      </h4>
      <p className="copies__copy">
        Medical imagery and dermatological education are important when it comes to diagnostic
        ability, but real-world experience is also essential, according to Dr. Rice. “Those who are
        African-American can have a span of typical, classic eczema that can be harder to diagnose
        for some if they're not used to looking at skin of color,” Dr. Rice says. Reference photos
        are important but hands-on training with patients of color is extremely important for
        medical students. “Virtual images are great, but there is nothing like having an away
        rotation and going to a place where you know you're going to see a lot of patients with skin
        of color for a month,” she says.
        <sup className="copies__copy--sup">8</sup>
      </p>
      <p className="copies__copy">
        Representation in the dermatology field needs to be mainstream, just as discussion of race
        in general. “This is not something that belongs on the sidelines anymore,” Dr. Rice says. “I
        feel like for me and my dermatology residents, we're so comfortable talking about this and
        dealing in different skin types; I wish that was the case for everyone.”
        <sup className="copies__copy--sup">8</sup>
      </p>
      <p className="copies__copy">
        On the research front, there’s recognition within the field of medical dermatology that
        clinical trials have lacked diversity in the past; moving forward, pharmaceutical companies
        are committing to design clinical trials so that enrollment can reflect the racial and
        ethnic diversity of the populations impacted.
      </p>
    </section>
  );
}

export default Copy5;
